import FormSection from '~/components/form/FormSection.vue'
import Channels from '~/components/Channels.vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:setup', () => {
    nuxtApp.vueApp.component('FormSection', FormSection)
    nuxtApp.vueApp.component('Channels', Channels)
  })
})
